/**
 * The `bat.platform_jobs.job_type` values that are a customer's IMPORTS.
 *
 * `csv-import-with-mapping` is what EVERY template-based CSV import is stamped
 * with (`import-job-orchestrator.service.ts`), the most used path. The lists
 * hand-written in each reader forgot it: the organisation panel's "Imports"
 * widget said "No imports" for an organisation with three completed imports,
 * and the super admin dashboard's import count left out 768 of 1,296.
 *
 * `csv-import` is still alive: the unknown-rows reprocessor and the CSV sync
 * create it.
 */
export const CUSTOMER_IMPORT_JOB_TYPES = [
  'api-import',
  'csv-import',
  'csv-import-with-mapping',
  'wallet_import',
] as const

export type CustomerImportJobType = (typeof CUSTOMER_IMPORT_JOB_TYPES)[number]
